<template>
  <el-container id="app-container">
    <el-main>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </el-main>
  </el-container>
</template>

<script setup>
import { useStoreCname } from '@/composables/useStoreCname'
import { addDatadogGlobalContext } from '@/utils'

const route = useRoute()
const storeCname = useStoreCname()
const designerId = computed(() => route.query.userId ?? null)

onMounted(() => {
  addDatadogGlobalContext({ key: 'code', value: storeCname.value })
  addDatadogGlobalContext({ key: 'designerId', value: designerId.value })
})
</script>
